import { Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({ providedIn: 'root' })
export class AdminMenuService {
  getMenu(): SubMenu {
    return {
      root: { label: 'main-menu.admin', routerLink: AppRoutes.Admin.root },
      items: [
        { label: 'sub-menu-admin.input-archive', routerLink: AppRoutes.Admin.root },
        { label: 'sub-menu-admin.output-archive', routerLink: AppRoutes.Admin.OutputArchive },
      ],
    };
  }
}
